import script from "./ProductSidebarSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSidebarSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ProductSidebarSkeleton.vue?vue&type=style&index=0&id=8a0c3e14&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a0c3e14"]])

export default __exports__